import { ConnectionTypeContractModel } from "./ConnectionTypeContract.model";
import { FlowModel } from "./Flow.model";

export class ConnectionTypeModel {
    
    Id : number;
    IdSystem : number;
    Name : string;
    ContractTerms: []
    ConnectionTypeContract: ConnectionTypeContractModel[]
    IsActive : boolean;
    CreatedBy : string;
    CreatedDate : Date;
    ModifiedBy : string;
    ModifiedDate : Date;
    Flows:FlowModel[]
  }
  